import React from 'react';
import { cn } from '@/utils/cn';
import { Button } from '@/components/ui/Button';
import { Plus } from 'lucide-react';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  compact?: boolean;
  className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  actionLabel,
  onAction,
  compact = false,
  className,
}) => (
  <div
    className={cn(
      'flex flex-col items-center justify-center text-center',
      compact ? 'py-6' : 'py-10',
      className
    )}
  >
    {icon && (
      <div
        className={cn(
          'rounded-full bg-neutral-100 flex items-center justify-center text-neutral-500',
          compact ? 'h-10 w-10 mb-2' : 'h-12 w-12 mb-3'
        )}
      >
        {icon}
      </div>
    )}
    <div className={cn('font-medium text-neutral-800', compact ? 'text-xs' : 'text-sm')}>
      {title}
    </div>
    {description && (
      <p className={cn('text-neutral-500 mt-1', compact ? 'text-[10px]' : 'text-xs')}>
        {description}
      </p>
    )}
    {actionLabel && onAction && (
      <Button data-testid="empty-state-action-btn" size="sm" className="mt-4" onClick={onAction}>
        <Plus size={12} /> {actionLabel}
      </Button>
    )}
  </div>
);

export { EmptyState };
